// SPDX-License-Identifier: Elastic-2.0
/**
 * GenericView — fallback for device types we don't yet have a dedicated
 * editor for. Renders the raw `device.state` as JSON in a monospace
 * `<pre>` block.
 *
 * Per task spec § 8 and per functional spec § 1: the "generic" bucket
 * exists so a freshly-translated HA domain still has a (read-only) modal
 * even before we ship a typed editor.
 */
import type { Device } from "@/api/gateway";

import styles from "../DeviceModal.module.css";

export interface GenericViewProps {
  device: Device;
}

export function GenericView({ device }: GenericViewProps): JSX.Element {
  const json = JSON.stringify(device.state ?? {}, null, 2);
  return (
    <pre className={styles.genericState} data-testid="generic-view">
      {json}
    </pre>
  );
}

export default GenericView;
